const { coreApi } = require('../utils/axios');

async function getCampaigns(page, limit) {
  try {
    const query = new URLSearchParams({ page, limit }).toString();
    const response = await coreApi.get(`/campaigns?${query}`);
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

async function getCampaign(campaignId) {
  try {
    const response = await coreApi.get(`/campaigns/${campaignId}`);
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

const createCampaign = async (formData = {}) => {
  try {
    const response = await coreApi.post('/campaigns', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
};

const updateCampaign = async (_id, formData = {}) => {
  try {
    const response = await coreApi.put(`/campaigns/${_id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
};

async function deleteCampaign(campaignId) {
  try {
    const response = await coreApi.delete(`/campaigns/${campaignId}`);
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

async function sendCampaign(campaignId) {
  try {
    const response = await coreApi.post(`/campaigns/${campaignId}/send`);
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

async function getAppDeepLinks() {
  try {
    const response = await coreApi.get(`/app-deep-links`);
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

async function getClinics() {
  try {
    const response = await coreApi.get('/clinics');
    return response;
  } catch (error) {
    if (error.response) throw new Error(error.response.data?.error?.text);
    throw new Error(error.message);
  }
}

const campaignsAPI = {
  getCampaigns,
  getCampaign,
  createCampaign,
  updateCampaign,
  deleteCampaign,
  sendCampaign,
  getAppDeepLinks,
  getClinics,
};

export default campaignsAPI;
